import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('address.routes.index'),
        name: 'address.index',
        child: false,
        component: () =>
            import(
                /* webpackChunkName: "address" */ '@/views/addresses/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('address.breadcrumbs.index'),
                    to: { name: 'address.index' },
                    disable: true,
                },
            ],
            showName: i18n.t('address.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('address.routes.create'),
        name: 'address.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "address" */ '@/views/addresses/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('address.breadcrumbs.index'),
                    to: { name: 'address.index' },
                    disable: false,
                },
                {
                    text: i18n.t('address.breadcrumbs.create'),
                    to: { name: 'address.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('address.routes.edit') + '/:id',
        name: 'address.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "address" */ '@/views/addresses/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('address.breadcrumbs.index'),
                    to: { name: 'address.index' },
                    disable: false,
                },
                {
                    text: i18n.t('address.breadcrumbs.edit'),
                    to: { name: 'address.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
